/**
 * Function to open user profile page
 * @param owner
 * @param subjectID
 * @returns
 */
function userProfile(owner, subjectID, scope) {

	var url = "../misc/userProfile.jsp?userId="+subjectID+"&edit=0";
	var idDialog = subjectID+'_profileDialog';

	var width = 1024;
	var height = '80%';

	switch (scope) {
	case 'INVITATION':
		customTitle = LANGUAGES.getOriginalLabel("UserProfile");
		jQDialogIframe(idDialog, customTitle, url, width, height, "", true, true, true, true);
		break;

	case 'ONDIALOG' :
		closeAllTips();
		customTitle = LANGUAGES.getOriginalLabel("UserProfile");
		jQDialogIframe(idDialog, customTitle, url, width, height, "", true, true, true, true);
		break;


	case 'DEFAULT' :
		rootPage.navigateToContent(url);
		break;

	default:
		rootPage.navigateToContent(url);
		break;
	}

	return;
}

/* ******************************************************************************************
 * Decisyon Api : a singletone object
 ****************************************************************************************** */

var DecisyonApi = (function (TemplateModelsRestProvider) {
	var instance;

	function createInstance() {

		var object = {
				userInfo : {},
				localization : {},
				utils : new DcyGenericApi(),
				window : {
					section : {
						element : function(customJsId){
							var dshElement = window.DSH_PAGE.getDshElementFromCustomJsId(customJsId);
							if(dshElement){
								return dshElement.api();
							}
							return null;
						}
					},
					dashboards : function(customJsId){
						return getDshPagesByCustomJsId(customJsId);
					},
					element : function(){}
				},
				ng: {
					register: {}
				},
				// Api only alpha version
				alpha: {
					addWatchToParam: {}
				},
				//Sets
				setSection : function(section){
					//Da ricontrollare. Genera problemi di memory leak perchè referenzia funzioni javascript legate alla window del mashboard
					//instance.window.section = jQuery.extend({}, instance.window.section, section);
				},
				i18n : {},
				l10n : {},
				setUserInfo : function(userInfo){
					if(typeof userInfo == "object"){
						instance.userInfo.selectedLanguage = LANGUAGES.getLanguage().toLowerCase();
						instance.userInfo.id = userInfo.id;
						instance.userInfo.username = userInfo.username;
						instance.userInfo.name = userInfo.name;
						instance.userInfo.surname = userInfo.surname;
						instance.userInfo.fullname = userInfo.fullname;
						instance.userInfo.timezone = userInfo.timeZone;
					}
				},
				app: {
					logout: function() {
						rootPage.logoutFunction();
					}
				},
				widgetHub: {
					getEnviromentInfo: {},
					getPublishedWidgets: {},
					getPublishedWidget: {},
					installWidget: {},
					upgradeWidget: {}
				},
				api : function(){
					return {
//						window : object.window,
						i18n : object.i18n,
						ng: {
							register: object.ng.register
						},
						alpha : {
							addWatchToParam : object.alpha.addWatchToParam
						},
						userInfo : object.userInfo,
						app: {
							logout: object.app.logout
						},
						widgetHub: {
							getEnviromentInfo: object.widgetHub.getEnviromentInfo,
							getPublishedWidgets: object.widgetHub.getPublishedWidgets,
							getPublishedWidget: object.widgetHub.getPublishedWidget,
							installWidget: object.widgetHub.installWidget,
							upgradeWidget: object.widgetHub.upgradeWidget
						}
					};
				}
		};

		return object;
	}

	return {
		getInstance: function () {
			if (!instance) {
				instance = createInstance();
			}
			return instance;
		}
	};
})(window.TemplateModelsRestProvider);

function appendUserFontCssRole(){
	let css = `a, abbr, acronym, address, applet, article, aside, audio, b, blockquote, big, body, center, canvas, caption, cite, code, command, datalist, dd, del, details, dfn, dl, dt, em, embed,
		fieldset, figcaption, figure, font, footer, form, h1, h2, h3, h4, h5, h6, header, hgroup, html, iframe, img, ins, kbd, keygen, label, legend, li, meter, nav, object, ol, output, p, pre, progress,
		q, s, samp, section, small, source, strike, strong, sub, sup, table, tbody, tfoot, thead, th, tr, tdvideo, tt, u, ul, li, input, textarea, button {
			font-family : \'` + ENV_VARS.getWorkspaceFont() + `\'!important;\n	}
		md-icon, md-icon * { font-family : "Material Icons"!important;\nfont-weight : normal; } 
		.mce-ico {font-family: "tinymce",Arial!important; }`;
	let head 	= document.head || document.getElementsByTagName('head')[0];
	let style 	= document.createElement('style');

	style.type = 'text/css';

	if (style.styleSheet){
		style.styleSheet.cssText = css;
	} else {
		style.appendChild(document.createTextNode(css));
	}

	head.appendChild(style);
}

/*
 *  Decisyon : a singletone object
 */
var Decisyon = (function () {
  var instance;

  function createApiInstance() {
      return DecisyonApi.getInstance();
  }

  return {
      getInstance: function () {
          if (!instance) {
          	instance = createApiInstance();
          }
          return instance;
      }
  };
})();

var DECISYON_CORE = Decisyon.getInstance();
appendUserFontCssRole();
